<form [formGroup]="form">
  <app-input-group>
    <label appLabel>{{ 'dashboard.servicerequest.complete.meteringpoint' | translate }}</label>
    <input appInput type="text" formControlName="meteringPointIdentification" readonly>
  </app-input-group>

  @if (form.get('address')?.value) {
    <app-input-group>
      <label appLabel>
        {{ 'address.title' | translate }}
      </label>
      <input appInput type="text" formControlName="address" readonly>
    </app-input-group>
  }

  <app-input-group>
    <label appLabel>{{ 'dashboard.servicerequest.complete.date' | translate }}</label>
    <div helpText>{{ 'dashboard.servicerequest.complete.dateHelpText' | translate }}</div>
    <input appInput type="date" formControlName="date">
  </app-input-group>

  <app-input-group>
    <label appLabel>{{ 'dashboard.servicerequest.complete.reply' | translate }}</label>
    <label class="ec-radio-label">
      <input appInput type="radio" formControlName="response"
             [value]="UserResponse.Approved"> {{ 'dashboard.servicerequest.complete.approve' | translate }}
    </label>
    <label class="ec-radio-label">
      <input appInput type="radio" formControlName="response"
             [value]="UserResponse.Rejected"> {{ 'dashboard.servicerequest.complete.deny' | translate }}
    </label>
  </app-input-group>

  @if (form.get('response')?.value !== UserResponse.Rejected && actionType !== 'metercontrol') {
    <app-input-group>
      <label for="chargeInformationId" appLabel>
        {{ 'chargeInformation.chargeTypes.fee' | translate }}
      </label>
      <select
        id="chargeInformationId"
        formControlName="chargeInformationId"
        appInput>
        <option [ngValue]="null">{{ 'chargeInformation.chargeTypes.noFee' | translate }}</option>
        @for (chargeInfo of chargeInformations; track chargeInfo.id) {
          <option [value]="chargeInfo.id">
            {{ chargeInfo.chargeTypeId }} - {{ chargeInfo.description }}
          </option>
        }
      </select>
    </app-input-group>
  }

  <app-input-group>
    <label appLabel>{{ 'dashboard.servicerequest.complete.reasontext' | translate }}</label>
    <textarea appInput formControlName="reasonText"></textarea>
  </app-input-group>

</form>
